import {
	comMapping
} from '../../../util/Function/comMapping.js'
export function getdata() {
	var obj = {
		searchlist: [{
				prop: "nsrmc",
				label: '纳税人名称',
				type: "input"
			},
			{
				prop: "nsrsbh",
				label: '纳税人识别号',
				type: "input"
			},
			{
				prop: "companyCode",
				label: '公司代码',
				type: "input"
			},
			{
				prop: "shuizId",
				label: '税表名称',
				type: "select",
				selectval: []
			},
			{
				prop: "ybtse",
				label: '应补（退）税额（附加税额）',
				type: "input"
			},
			{
				prop: "bbzt",
				label: '报表状态',
				type: "select",
				selectval: comMapping.$bbztsb
			},

			{
				prop: "isComplete",
				label: '是否完成',
				type: "select",
				selectval: [{
					label: "是",
					value: "1"
				}, {
					label: "否",
					value: "0"
				}, ]
			},
			{
				prop: "czsjjs",
				label: '最近操作时间',
				type: "datetimerange",
				valueformat: 'yyyy-MM-dd hh:mm:ss'
			},
			{
				prop: "czr",
				label: '操作人',
				type: "input"
			},
		],
		headseeData: [{
				title: "类型",
				prop: "type",
				custom: true
			},
			{
				title: "名称",
				prop: "name",
			},
			{
				title: "描述",
				prop: "description",
				width: "200"
			},
			{
				title: "操作",
				prop: "cz",
				custom: true,
				width: "120"
			},
		],
		paginationfile: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		searchdata: {
			nsrmc: "",
			companyCode: "",
			shuizId: "",
			bbzt: "",
			nsrsbh: '',
			ybtse: '',
			fxs: '',
			fjs: '',
			isComplete: '',
			czsjjs: '',
			czr: '',
		},
		tableData: [],
		formlist: [{
			prop: "type",
			label: "类型",
			type: "select",
			width: "220px",
			selectval: [{
					label: "报表 ",
					value: "1"
				},
				{
					label: "完税凭证",
					value: "2"
				},
				{
					label: "涉税资料",
					value: "3"
				},
				{
					label: "强制弹框附注",
					value: "4"
				}
			]

		}, {
			prop: "name",
			label: "名称",
			type: "input",
			width: "380px"

		}, {
			prop: "description",
			label: "描述",
			type: "textarea",
			width: "220px"

		}],
		headData: [{
				title: "纳税人名称",
				custom: true,
				prop: "nsrmc",
				width: 160,
				
			},
			{
				title: "公司代码",
				custom: true,
				prop: "companyCode",
				width: "80"
			},
			{
				title: "税表名称",
				prop: "sbzl",
				custom: true,
				headcustom: true,
				width: 160,
				headprop: 'sbzlhead'
			},
			{
				title: "应补（退）税额（附加税额）",
				prop: "ybtse",
				width: "130",
				AmountFormat: true,
				custom: true,
			},
			{
				title: "报表状态",
				prop: "status",
				width: "130",
				custom: true,
			},
			{
				title: "最近操作时间",
				custom: true,
				prop: "zjczsj",
				width: "130",
			},
			{
				title: "风险",
				prop: "fxs",
				custom: true,
				width: "80",
			},
			{
				title: "附件",
				prop: "fjs",
				custom: true,
				width: "80",
			},
			{
				title: "是否完成",
				prop: "isComplete",
				custom: true,
				width: "80"
			}, {
				title: "税款所属期起",
				custom: true,
				prop: "shenbqFrom",
				width: "160"
			},
			{
				title: "税款所属期止",
				custom: true,
				prop: "shenbqTo",
				width: "160"
			},
			{
				title: "申报截至日期",
				custom: true,
				prop: "shenbEndDate",
				width: "160"
			},
			{
				title: "操作",
				prop: "cz",
				fixed: "right",
				custom: true,
				width: "280px"
			},
		],
		headDatafx: [{
				title: "指标编号",
				prop: "",
			},
			{
				title: "指标大类",
				prop: "",
			},
			{
				title: "指标类型",
				prop: "",
			},
			{
				title: "指标名称",
				prop: "",
				width: "200px"
			},
			{
				title: "预警值",
				prop: "",
			},
			{
				title: "当前值",
				prop: "",
			},
			{
				title: "最新更新时间",
				prop: "",
				width: "200px"
			},
		]
	}
	return obj
}
